import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const fmt = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const MESES = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

export default function Revendedores() {
  const { usuario } = useAuth();
  const [vista, setVista]           = useState('lista'); // lista | clientes | cobros
  const [revendedores, setRevs]     = useState([]);
  const [seleccionado, setSel]      = useState(null);
  const [clientes, setClientes]     = useState([]);
  const [cobros, setCobros]         = useState([]);
  // Lo recaudado de sus clientes, lo que se queda LinkUs y lo que le queda a él.
  const [balance, setBalance]       = useState(null);
  const [pendientes, setPendientes] = useState([]);
  const [modal, setModal]           = useState(false);
  const [editando, setEditando]     = useState(null);
  const [modalPago, setModalPago]   = useState(null);
  const [genMes, setGenMes]         = useState({ mes: new Date().getMonth()+1, anio: new Date().getFullYear() });
  const [cargando, setCargando]     = useState(false);
  const [msg, setMsg]               = useState('');
  const [form, setForm]             = useState({ nombre:'', contacto:'', nit:'', telefono:'', email:'', direccion:'', tarifa_por_cliente:'', dia_cobro:1, notas:'', modo_cobro:'al_revendedor' });

  const cargar = useCallback(async () => {
    const [r, p] = await Promise.all([
      api.get('/api/revendedores'),
      api.get('/api/revendedores/cobros/pendientes'),
    ]);
    setRevs(r.data);
    setPendientes(p.data);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const verDetalle = async (rev) => {
    setSel(rev);
    const [cl, co] = await Promise.all([
      api.get(`/api/revendedores/${rev.id}/clientes`),
      api.get(`/api/revendedores/${rev.id}/cobros`),
    ]);
    setClientes(cl.data);
    setCobros(co.data);
    /* Antes ponía 'detalle', y ese valor NO lo lee nadie: los dos paneles de abajo preguntan
       por 'clientes' y por 'cobros'. O sea que al abrir un revendedor no salía ninguno de los
       dos —ficha arriba, dos pestañas apagadas, y debajo nada— hasta tocar una pestaña, sin
       que nada dijera que había que tocarla. Se entra por la de clientes, que es la que
       contesta la pregunta de «¿quiénes son sus clientes?». */
    setVista('clientes');
    /* El balance va aparte y sin bloquear: si falla, el detalle se ve igual. Es un número
       que se calcula al vuelo de los pagos, no una tabla que se pueda quedar a medias. */
    api.get(`/api/revendedores/${rev.id}/balance`)
      .then(({ data }) => setBalance(data))
      .catch(() => setBalance(null));
  };

  const abrirModal = (rev=null) => {
    if (rev) {
      setForm({ nombre:rev.nombre, contacto:rev.contacto||'', telefono:rev.telefono||'', email:rev.email||'', nit:rev.nit||'', direccion:rev.direccion||'', tarifa_por_cliente:rev.tarifa_por_cliente, dia_cobro:rev.dia_cobro, notas:rev.notas||'', modo_cobro: rev.modo_cobro || 'al_revendedor' });
      setEditando(rev);
    } else {
      setForm({ nombre:'', contacto:'', nit:'', telefono:'', email:'', direccion:'', tarifa_por_cliente:'', dia_cobro:1, notas:'', modo_cobro:'al_revendedor' });
      setEditando(null);
    }
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre || !form.tarifa_por_cliente) return setMsg('Nombre y tarifa son obligatorios');
    setCargando(true);
    try {
      if (editando) {
        await api.put(`/api/revendedores/${editando.id}`, form);
      } else {
        await api.post('/api/revendedores', form);
      }
      setModal(false);
      cargar();
      if (seleccionado) verDetalle({ ...seleccionado, ...form });
      setMsg('');
    } catch(e) { setMsg(e.response?.data?.error || 'Error al guardar'); }
    setCargando(false);
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar revendedor? Sus clientes quedarán sin revendedor asignado.')) return;
    await api.delete(`/api/revendedores/${id}`);
    cargar();
    setVista('lista');
  };

  const generarCobros = async () => {
    setCargando(true);
    try {
      const r = await api.post('/api/revendedores/generar-cobros', genMes);
      alert(r.data.mensaje);
      cargar();
    } catch(e) { alert(e.response?.data?.error || 'Error'); }
    setCargando(false);
  };

  const registrarPago = async () => {
    try {
      await api.put(`/api/revendedores/cobros/${modalPago.id}/pagar`, { fecha_pago: modalPago.fecha_pago });
      setModalPago(null);
      if (seleccionado) {
        const co = await api.get(`/api/revendedores/${seleccionado.id}/cobros`);
        setCobros(co.data);
      }
      cargar();
    } catch(e) { alert('Error al registrar pago'); }
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const esAdmin = ['admin','superadmin'].includes(usuario?.rol);

  // ── ESTILOS ────────────────────────────────────────────────
  const cs = {
    page:  { padding:'24px', maxWidth:'1200px', margin:'0 auto' },
    card:  { background:'rgba(255,255,255,0.04)', borderRadius:'12px', boxShadow:'none', padding:'20px', marginBottom:'16px' },
    h1:    { fontSize:'22px', fontWeight:'700', margin:'0 0 20px', color:'#fff' },
    h2:    { fontSize:'16px', fontWeight:'700', margin:'0 0 14px', color:'rgba(255,255,255,0.9)' },
    btn:   { padding:'8px 16px', borderRadius:'8px', border:'none', cursor:'pointer', fontWeight:'600', fontSize:'13px' },
    btnP:  { background:'#2563EB', color:'#fff' },
    btnG:  { background:'#16A34A', color:'#fff' },
    btnR:  { background:'#DC2626', color:'#fff' },
    btnW:  { background:'rgba(255,255,255,0.1)', color:'rgba(255,255,255,0.85)' },
    badge: { padding:'3px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'600' },
    input: { width:'100%', padding:'9px 12px', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.12)', fontSize:'14px', boxSizing:'border-box', background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.9)', outline:'none', fontFamily:'inherit' },
    label: { fontSize:'12px', fontWeight:'600', color:'rgba(255,255,255,0.5)', display:'block', marginBottom:'4px' },
    grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' },
    table: { width:'100%', borderCollapse:'collapse' },
    th:    { textAlign:'left', padding:'10px 12px', fontSize:'12px', fontWeight:'700', color:'rgba(255,255,255,0.45)', borderBottom:'2px solid rgba(255,255,255,0.1)', textTransform:'uppercase', letterSpacing:'0.5px' },
    td:    { padding:'12px', fontSize:'13px', borderBottom:'1px solid rgba(255,255,255,0.05)', verticalAlign:'middle' },
  };

  // ── VISTA LISTA ────────────────────────────────────────────
  if (vista === 'lista') return (
    <Layout>
    <div style={cs.page}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px', flexWrap:'wrap', gap:'10px' }}>
        <h1 style={{ fontSize:'22px', fontWeight:'700', margin:0 }}>👥 Revendedores</h1>
        <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
          {esAdmin && (
            <>
              <select style={{ ...cs.input, width:'auto', padding:'8px 12px' }} value={genMes.mes} onChange={e=>setGenMes(p=>({...p,mes:+e.target.value}))}>
                {MESES.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
              </select>
              <input type="number" style={{ ...cs.input, width:'90px', padding:'8px 12px' }} value={genMes.anio} onChange={e=>setGenMes(p=>({...p,anio:+e.target.value}))}/>
              <button style={{...cs.btn,...cs.btnG}} onClick={generarCobros} disabled={cargando}>
                {cargando?'Generando...':'⚡ Generar cobros'}
              </button>
              <button style={{...cs.btn,...cs.btnP}} onClick={()=>abrirModal()}>+ Nuevo revendedor</button>
            </>
          )}
        </div>
      </div>

      {/* Cobros pendientes */}
      {pendientes.length > 0 && (
        <div style={{ ...cs.card, border:'1px solid rgba(239,68,68,0.3)', background:'rgba(239,68,68,0.1)' }}>
          <h2 style={{ ...cs.h2, color:'#FCA5A5' }}>⚠️ Cobros pendientes ({pendientes.length})</h2>
          <table style={cs.table}>
            <thead><tr>
              <th style={cs.th}>Revendedor</th><th style={cs.th}>Período</th>
              <th style={cs.th}>Clientes</th><th style={cs.th}>Total</th>
              {esAdmin && <th style={cs.th}>Acción</th>}
            </tr></thead>
            <tbody>
              {pendientes.map(p=>(
                <tr key={p.id}>
                  <td style={cs.td}><strong>{p.revendedor_nombre}</strong><br/><span style={{fontSize:'12px',color:'rgba(255,255,255,0.45)'}}>{p.revendedor_telefono}</span></td>
                  <td style={cs.td}>{MESES[p.periodo_mes]} {p.periodo_anio}</td>
                  <td style={cs.td}>{p.clientes_activos}</td>
                  <td style={cs.td}><strong style={{color:'#FCA5A5'}}>{fmt(p.monto_total)}</strong></td>
                  {esAdmin && <td style={cs.td}>
                    <button style={{...cs.btn,...cs.btnG}} onClick={()=>setModalPago({...p, fecha_pago:new Date().toISOString().split('T')[0]})}>
                      ✓ Registrar pago
                    </button>
                  </td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Lista de revendedores */}
      <div style={cs.card}>
        {revendedores.length === 0 ? (
          <div style={{ textAlign:'center', padding:'40px', color:'#9CA3AF' }}>
            <div style={{ fontSize:'40px', marginBottom:'10px' }}>👥</div>
            <p>No hay revendedores registrados</p>
          </div>
        ) : (
          <table style={cs.table}>
            <thead><tr>
              <th style={cs.th}>Revendedor</th>
              <th style={cs.th}>Contacto</th>
              <th style={cs.th}>Tarifa/cliente</th>
              <th style={cs.th}>Clientes activos</th>
              {/* Decía «Cobro mensual», igual que la casilla de la ficha, y es el mismo
                  malentendido: a él no se le cobra nada. La cifra es clientes × tarifa, o
                  sea lo que será de LinkUs ese mes SI pagan todos — no lo que entró ni lo
                  que se le factura. Con el nombre viejo, un revendedor con morosos parecía
                  deberle a LinkUs una plata que nadie le va a cobrar. */}
              <th style={cs.th}>Tarifa del mes si pagan todos</th>
              <th style={cs.th}>Estado</th>
              <th style={cs.th}>Acciones</th>
            </tr></thead>
            <tbody>
              {revendedores.map(r=>(
                <tr key={r.id} style={{ cursor:'pointer' }} onClick={()=>verDetalle(r)}>
                  <td style={cs.td}>
                    <strong>{r.nombre}</strong>
                    {r.nit && <div style={{fontSize:'12px',color:'rgba(255,255,255,0.45)'}}>NIT {r.nit}</div>}
                  </td>
                  <td style={cs.td}>
                    {r.telefono && <div>{r.telefono}</div>}
                    {r.email && <div style={{fontSize:'12px',color:'rgba(255,255,255,0.45)'}}>{r.email}</div>}
                  </td>
                  <td style={cs.td}>{fmt(r.tarifa_por_cliente)}</td>
                  <td style={cs.td}><strong>{r.clientes_activos || 0}</strong></td>
                  <td style={cs.td}>
                    <strong style={{color:'#2563EB'}}>
                      {fmt((r.clientes_activos||0) * r.tarifa_por_cliente)}
                    </strong>
                  </td>
                  <td style={cs.td}>
                    {/* La columna se llama `activo` y es booleana. Esto leía `estado`, que en
                        esta tabla no existe, así que la casilla salía SIEMPRE en blanco. */}
                    <span style={{ ...cs.badge, background: r.activo?'#DCFCE7':'#F3F4F6', color: r.activo?'#16A34A':'#6B7280' }}>
                      {r.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td style={cs.td} onClick={e=>e.stopPropagation()}>
                    <div style={{ display:'flex', gap:'6px' }}>
                      {esAdmin && <button style={{...cs.btn,...cs.btnW}} onClick={()=>abrirModal(r)}>✏️</button>}
                      {esAdmin && <button style={{...cs.btn,...cs.btnR}} onClick={()=>eliminar(r.id)}>🗑️</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal crear/editar */}
      {modal && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center' }}>
          <div style={{ background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto' }}>
            <h2 style={cs.h2}>{editando?'Editar revendedor':'Nuevo revendedor'}</h2>
            {msg && <div style={{ background:'rgba(239,68,68,0.1)',color:'#DC2626',padding:'10px',borderRadius:'8px',marginBottom:'14px',fontSize:'13px' }}>{msg}</div>}
            <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
              <div><label style={cs.label}>Nombre *</label><input style={cs.input} value={form.nombre} onChange={e=>f('nombre',e.target.value)}/></div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Contacto</label><input style={cs.input} value={form.contacto} onChange={e=>f('contacto',e.target.value)}/></div>
                <div><label style={cs.label}>Teléfono</label><input style={cs.input} value={form.telefono} onChange={e=>f('telefono',e.target.value)}/></div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>NIT / Cédula</label><input style={cs.input} value={form.nit} onChange={e=>f('nit',e.target.value)}/></div>
                <div><label style={cs.label}>Email</label><input style={cs.input} type="email" value={form.email} onChange={e=>f('email',e.target.value)}/></div>
              </div>
              <div><label style={cs.label}>Dirección</label><input style={cs.input} value={form.direccion} onChange={e=>f('direccion',e.target.value)}/></div>
              <div style={cs.grid2}>
                <div>
                  <label style={cs.label}>Tarifa por cliente ($/mes) *</label>
                  <input style={cs.input} type="number" value={form.tarifa_por_cliente} onChange={e=>f('tarifa_por_cliente',e.target.value)}/>
                </div>
                <div>
                  <label style={cs.label}>Día de cobro</label>
                  <input style={cs.input} type="number" min="1" max="28" value={form.dia_cobro} onChange={e=>f('dia_cobro',+e.target.value)}/>
                </div>
              </div>

              {/* Hay DOS tratos y el sistema solo entendía uno. Esto decide de dónde sale la
                  plata de LinkUs, así que es lo que más cambia los números de este revendedor:
                  con «al_revendedor» sus clientes NO salen en la Cartera y se le pasa una
                  cuenta al mes; con «al_cliente» se le cobra a cada cliente y se reparte. */}
              <div>
                <label style={cs.label}>¿Quién le cobra a sus clientes?</label>
                {[['al_revendedor', '👤 Él les cobra a sus clientes',
                   'Él decide cuánto les cobra y te paga UNA cuenta al mes: clientes × tarifa. Sus clientes no salen en tu Cartera.'],
                  ['al_cliente', '🏢 Les cobro yo, como a Oscar Iván',
                   'Tú le cobras a cada cliente la mensualidad completa, te quedas la tarifa y el resto se lo debes a él.']
                 ].map(([v, titulo, explica]) => (
                  <label key={v} style={{ display:'flex', alignItems:'flex-start', gap:'10px',
                      cursor:'pointer', padding:'11px', marginTop:'7px', borderRadius:'10px',
                      background: form.modo_cobro===v ? 'rgba(99,102,241,0.12)' : 'rgba(255,255,255,0.03)',
                      border: `1px solid ${form.modo_cobro===v ? 'rgba(99,102,241,0.45)' : 'rgba(255,255,255,0.1)'}` }}>
                    <input type="radio" name="modo_cobro" checked={form.modo_cobro===v}
                      onChange={()=>f('modo_cobro', v)}
                      style={{ marginTop:'3px', width:'16px', height:'16px', cursor:'pointer', flexShrink:0 }}/>
                    <span>
                      <span style={{ fontWeight:'600', color: form.modo_cobro===v ? '#A5B4FC' : 'rgba(255,255,255,0.85)' }}>{titulo}</span>
                      <span style={{ display:'block', fontSize:'12px', color:'rgba(255,255,255,0.5)', marginTop:'3px' }}>{explica}</span>
                    </span>
                  </label>
                ))}
              </div>
              <div><label style={cs.label}>Notas del contrato</label><textarea style={{ ...cs.input, minHeight:'70px', resize:'vertical' }} value={form.notas} onChange={e=>f('notas',e.target.value)}/></div>
            </div>
            <div style={{ display:'flex', gap:'10px', marginTop:'20px', justifyContent:'flex-end' }}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>{setModal(false);setMsg('');}}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnP}} onClick={guardar} disabled={cargando}>{cargando?'Guardando...':'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal pago */}
      {modalPago && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center' }}>
          <div style={{ background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'400px' }}>
            <h2 style={cs.h2}>✓ Registrar pago</h2>
            <p style={{ fontSize:'14px', color:'rgba(255,255,255,0.85)', marginBottom:'16px' }}>
              <strong>{modalPago.revendedor_nombre}</strong> — {MESES[modalPago.periodo_mes]} {modalPago.periodo_anio}<br/>
              <span style={{ fontSize:'18px', fontWeight:'700', color:'#16A34A' }}>{fmt(modalPago.monto_total)}</span>
            </p>
            <div>
              <label style={cs.label}>Fecha de pago</label>
              <input type="date" style={cs.input} value={modalPago.fecha_pago} onChange={e=>setModalPago(p=>({...p,fecha_pago:e.target.value}))}/>
            </div>
            <div style={{ display:'flex', gap:'10px', marginTop:'20px', justifyContent:'flex-end' }}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>setModalPago(null)}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnG}} onClick={registrarPago}>✓ Confirmar pago</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );

  // ── VISTA DETALLE ──────────────────────────────────────────
  return (
    <Layout>
    <div style={cs.page}>
      <button style={{ ...cs.btn, ...cs.btnW, marginBottom:'16px' }} onClick={()=>setVista('lista')}>← Volver</button>

      {/* Header revendedor */}
      <div style={{ ...cs.card, display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:'12px' }}>
        <div>
          <h1 style={{ fontSize:'22px', fontWeight:'700', margin:'0 0 6px' }}>{seleccionado?.nombre}</h1>
          {seleccionado?.nit && <div style={{ fontSize:'14px', color:'rgba(255,255,255,0.45)' }}>NIT {seleccionado.nit}</div>}
          {seleccionado?.telefono && <div style={{ fontSize:'14px', color:'rgba(255,255,255,0.45)' }}>📞 {seleccionado.telefono}</div>}
          {seleccionado?.notas && <div style={{ fontSize:'13px', color:'rgba(255,255,255,0.45)', marginTop:'6px', fontStyle:'italic' }}>{seleccionado.notas}</div>}
        </div>
        <div style={{ display:'flex', gap:'8px' }}>
          {esAdmin && <button style={{...cs.btn,...cs.btnW}} onClick={()=>abrirModal(seleccionado)}>✏️ Editar</button>}
          {esAdmin && <button style={{...cs.btn,...cs.btnR}} onClick={()=>eliminar(seleccionado.id)}>🗑️ Eliminar</button>}
        </div>
      </div>

      {/* Resumen del mes */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:'14px', marginBottom:'16px' }}>
        {[
          { label:'Tarifa por cliente', valor: fmt(seleccionado?.tarifa_por_cliente), color:'#2563EB' },
          { label:'Clientes activos', valor: clientes.filter(c=>['activo','moroso'].includes(c.estado)).length, color:'#16A34A' },
          /* Decía «Cobro este mes», y ya no se le cobra nada: LinkUs cobra al cliente y se
             queda la tarifa. Peor aún, el número coincidía con lo que le queda a él cuando
             todos pagan, así que dos cosas distintas salían con la misma cifra al lado. Lo
             que esta casilla dice de verdad es cuánto será de LinkUs si pagan todos.
             Ojo: aquí va comentario de JavaScript, NO de JSX — esto es un arreglo, no JSX,
             y un comentario con llaves dentro de un arreglo no es un comentario: es un
             objeto vacío, o sea una tarjeta en blanco de más en la pantalla. */
          /* El mismo número quiere decir dos cosas distintas según el trato: con el de Beto
             es lo que se le factura a ÉL y es firme; con el de Oscar es lo que sería de
             LinkUs SI pagan todos, que depende de que paguen. Un solo rótulo para las dos
             haría leer mal la cifra justo donde se decide cuánto cobrar. */
          { label: (balance?.modo_cobro === 'al_revendedor' ? 'Le cobras este mes' : 'Tarifa del mes si pagan todos'),
            valor: fmt(clientes.filter(c=>['activo','moroso'].includes(c.estado)).length * (seleccionado?.tarifa_por_cliente||0)), color:'#D97706' },
          { label:'Total clientes', valor: clientes.length, color:'rgba(255,255,255,0.45)' },
        ].map(stat=>(
          <div key={stat.label} style={{ ...cs.card, textAlign:'center', marginBottom:0 }}>
            <div style={{ fontSize:'22px', fontWeight:'800', color:stat.color }}>{stat.valor}</div>
            <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.45)', marginTop:'4px' }}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/**
        * Balance del mes: cómo se partió la plata que pagaron sus clientes.
        *
        * Los tres números van JUNTOS y en este orden a propósito. Enseñar solo «lo que le
        * queda a él» obliga a creerse el número; con el recaudado y la tarifa al lado, la
        * cuenta se puede seguir con el dedo — que es lo que hace falta cuando hay que
        * aclarar el mes con el revendedor.
        */}
      {/* Con el trato normal —él le cobra a sus clientes— no hay nada que repartir: esos
          clientes no le pagan a LinkUs. Enseñar el bloque del reparto con todo en cero
          parecería una avería; lo que de verdad hay que ver es cuánto se le factura a él. */}
      {balance && balance.modo_cobro === 'al_revendedor' && (
        <div style={{ ...cs.card, marginBottom:'16px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', flexWrap:'wrap', gap:'10px' }}>
            <div>
              <h3 style={{ margin:'0 0 4px', fontSize:'15px', fontWeight:'700' }}>🧾 Lo que le cobras este mes</h3>
              <div style={{ fontSize:'12.5px', color:'rgba(255,255,255,0.55)', lineHeight:1.5 }}>
                {balance.clientes_activos} clientes × {fmt(balance.tarifa_por_cliente)}.
                Él le cobra a sus clientes lo que quiera: eso no pasa por aquí, y por eso
                no salen en tu Cartera.
              </div>
            </div>
            <div style={{ fontSize:'26px', fontWeight:'800', color:'#2563EB' }}>
              {fmt(balance.le_cobramos)}
            </div>
          </div>
        </div>
      )}

      {balance && balance.modo_cobro !== 'al_revendedor' && (
        <div style={{ ...cs.card, marginBottom:'16px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', flexWrap:'wrap', gap:'8px', marginBottom:'14px' }}>
            <h3 style={{ margin:0, fontSize:'15px', fontWeight:'700' }}>💰 Cómo se repartió este mes</h3>
            <span style={{ fontSize:'12px', color:'rgba(255,255,255,0.45)' }}>
              {balance.clientes_que_pagaron} de {balance.clientes_activos} clientes han pagado
            </span>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:'12px', alignItems:'center' }}>
            {[
              ['Recaudado de sus clientes', balance.recaudado, 'rgba(255,255,255,0.75)'],
              ['Se queda LinkUs (tarifa)',  balance.de_linkus, '#2563EB'],
              ['Le queda a él',             balance.del_revendedor, '#16A34A'],
            ].map(([txt, valor, color], i)=>(
              <div key={txt} style={{ textAlign:'center', position:'relative' }}>
                {/* El signo entre casillas dice que es una resta, no tres datos sueltos. */}
                {i > 0 && (
                  <span style={{ position:'absolute', left:'-9px', top:'6px', color:'rgba(255,255,255,0.3)', fontSize:'16px' }}>
                    {i === 1 ? '−' : '='}
                  </span>
                )}
                <div style={{ fontSize:'20px', fontWeight:'800', color }}>{fmt(valor)}</div>
                <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.45)', marginTop:'4px' }}>{txt}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.4)', marginTop:'14px', lineHeight:1.55 }}>
            Del pago de cada cliente, LinkUs se queda la tarifa del contrato y el resto es suyo.
            En <strong>Dinero</strong> solo entra la tarifa: {fmt(balance.del_revendedor)} entraron
            a la caja pero no son de LinkUs.
          </div>
          {!!balance.por_cliente?.length && (
            <details style={{ marginTop:'12px' }}>
              <summary style={{ cursor:'pointer', fontSize:'13px', color:'rgba(255,255,255,0.6)' }}>
                Ver cliente por cliente
              </summary>
              <table style={{ ...cs.table, marginTop:'10px' }}>
                <thead><tr>
                  <th style={cs.th}>Cliente</th><th style={cs.th}>Pagó</th>
                  <th style={cs.th}>LinkUs</th><th style={cs.th}>Suyo</th>
                </tr></thead>
                <tbody>
                  {balance.por_cliente.map(c=>(
                    <tr key={c.cliente}>
                      <td style={cs.td}>{c.cliente}</td>
                      <td style={cs.td}>{fmt(c.pago)}</td>
                      <td style={cs.td}>{fmt(c.de_linkus)}</td>
                      <td style={{ ...cs.td, color:'#16A34A', fontWeight:'600' }}>{fmt(c.del_revendedor)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </details>
          )}
        </div>
      )}

      {/* Tabs */}
      {/* El fondo era `#F3F4F6`, gris claro de cuando el sistema tenía tema claro, y los dos
          botones escriben en blanco: sobre ese gris las dos pestañas quedaban invisibles —
          se veía una barra blanca con dos emojis sueltos. Se usa el mismo estilo que las
          pestañas de Vendedores, que ya está hecho para el tema oscuro. */}
      <div style={{ display:'flex', gap:'8px', marginBottom:'16px', width:'fit-content' }}>
        {[['clientes','👥 Clientes'],['cobros','💰 Cobros']].map(([v,l])=>(
          <button key={v} onClick={()=>setVista(v)} style={{ ...cs.btn,
            background: vista===v ? 'rgba(99,102,241,0.15)' : 'rgba(255,255,255,0.03)',
            border: vista===v ? '1px solid rgba(99,102,241,0.5)' : '1px solid rgba(255,255,255,0.1)',
            color: vista===v ? '#A5B4FC' : 'rgba(255,255,255,0.55)',
            fontWeight: vista===v ? '600' : '400' }}>{l}</button>
        ))}
      </div>

      {/* Tab clientes */}
      {vista==='clientes' && (
        <div style={cs.card}>
          <h2 style={cs.h2}>Clientes del revendedor ({clientes.length})</h2>
          {clientes.length === 0 ? (
            <p style={{ color:'#9CA3AF', textAlign:'center', padding:'30px' }}>No tiene clientes asignados</p>
          ) : (
            <table style={cs.table}>
              <thead><tr>
                <th style={cs.th}>Cliente</th><th style={cs.th}>Plan</th>
                <th style={cs.th}>Estado</th><th style={cs.th}>Desde</th>
              </tr></thead>
              <tbody>
                {clientes.map(c=>(
                  <tr key={c.id}>
                    <td style={cs.td}><strong>{c.nombre}</strong>{c.telefono&&<div style={{fontSize:'12px',color:'rgba(255,255,255,0.45)'}}>{c.telefono}</div>}</td>
                    <td style={cs.td}>{c.plan_nombre||<span style={{color:'#9CA3AF'}}>Sin plan</span>}</td>
                    <td style={cs.td}>
                      <span style={{ ...cs.badge, background:c.estado==='activo'?'#DCFCE7':c.estado==='suspendido'?'#FEF3C7':'#FEE2E2', color:c.estado==='activo'?'#16A34A':c.estado==='suspendido'?'#D97706':'#DC2626' }}>
                        {c.estado}
                      </span>
                    </td>
                    <td style={cs.td}>{c.fecha_inscripcion ? new Date(c.fecha_inscripcion).toLocaleDateString('es-CO') : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab cobros */}
      {vista==='cobros' && (
        <div style={cs.card}>
          <h2 style={cs.h2}>Historial de cobros</h2>
          {cobros.length === 0 ? (
            <p style={{ color:'#9CA3AF', textAlign:'center', padding:'30px' }}>No hay cobros generados aún</p>
          ) : (
            <table style={cs.table}>
              <thead><tr>
                <th style={cs.th}>Período</th><th style={cs.th}>Clientes</th>
                <th style={cs.th}>Tarifa</th><th style={cs.th}>Total</th>
                <th style={cs.th}>Estado</th><th style={cs.th}>Fecha pago</th>
                {esAdmin && <th style={cs.th}>Acción</th>}
              </tr></thead>
              <tbody>
                {cobros.map(co=>(
                  <tr key={co.id}>
                    <td style={cs.td}><strong>{MESES[co.periodo_mes]} {co.periodo_anio}</strong></td>
                    <td style={cs.td}>{co.clientes_activos}</td>
                    <td style={cs.td}>{fmt(co.tarifa_unitaria)}</td>
                    <td style={cs.td}><strong>{fmt(co.monto_total)}</strong></td>
                    <td style={cs.td}>
                      <span style={{ ...cs.badge, background:co.estado==='pagado'?'#DCFCE7':'#FEE2E2', color:co.estado==='pagado'?'#16A34A':'#DC2626' }}>
                        {co.estado}
                      </span>
                    </td>
                    <td style={cs.td}>{co.fecha_pago ? new Date(co.fecha_pago).toLocaleDateString('es-CO') : '-'}</td>
                    {esAdmin && <td style={cs.td}>
                      {co.estado==='pendiente' && (
                        <button style={{...cs.btn,...cs.btnG}} onClick={()=>setModalPago({...co, fecha_pago:new Date().toISOString().split('T')[0], revendedor_nombre:seleccionado?.nombre})}>
                          ✓ Pagar
                        </button>
                      )}
                    </td>}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Modales (reutilizados) */}
      {modal && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center' }}>
          <div style={{ background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto' }}>
            <h2 style={cs.h2}>Editar revendedor</h2>
            {msg && <div style={{ background:'rgba(239,68,68,0.1)',color:'#DC2626',padding:'10px',borderRadius:'8px',marginBottom:'14px',fontSize:'13px' }}>{msg}</div>}
            <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
              <div><label style={cs.label}>Nombre *</label><input style={cs.input} value={form.nombre} onChange={e=>f('nombre',e.target.value)}/></div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Contacto</label><input style={cs.input} value={form.contacto} onChange={e=>f('contacto',e.target.value)}/></div>
                <div><label style={cs.label}>Teléfono</label><input style={cs.input} value={form.telefono} onChange={e=>f('telefono',e.target.value)}/></div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>NIT / Cédula</label><input style={cs.input} value={form.nit} onChange={e=>f('nit',e.target.value)}/></div>
                <div><label style={cs.label}>Email</label><input style={cs.input} type="email" value={form.email} onChange={e=>f('email',e.target.value)}/></div>
              </div>
              <div><label style={cs.label}>Dirección</label><input style={cs.input} value={form.direccion} onChange={e=>f('direccion',e.target.value)}/></div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Tarifa por cliente ($/mes) *</label><input style={cs.input} type="number" value={form.tarifa_por_cliente} onChange={e=>f('tarifa_por_cliente',e.target.value)}/></div>
                <div><label style={cs.label}>Día de cobro</label><input style={cs.input} type="number" min="1" max="28" value={form.dia_cobro} onChange={e=>f('dia_cobro',+e.target.value)}/></div>
              </div>
              <div><label style={cs.label}>Notas del contrato</label><textarea style={{ ...cs.input, minHeight:'70px', resize:'vertical' }} value={form.notas} onChange={e=>f('notas',e.target.value)}/></div>
            </div>
            <div style={{ display:'flex', gap:'10px', marginTop:'20px', justifyContent:'flex-end' }}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>{setModal(false);setMsg('');}}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnP}} onClick={guardar} disabled={cargando}>{cargando?'Guardando...':'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
      {modalPago && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center' }}>
          <div style={{ background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'400px' }}>
            <h2 style={cs.h2}>✓ Registrar pago</h2>
            <p style={{ fontSize:'14px', color:'rgba(255,255,255,0.85)', marginBottom:'16px' }}>
              <strong>{modalPago.revendedor_nombre}</strong> — {MESES[modalPago.periodo_mes]} {modalPago.periodo_anio}<br/>
              <span style={{ fontSize:'18px', fontWeight:'700', color:'#16A34A' }}>{fmt(modalPago.monto_total)}</span>
            </p>
            <div><label style={cs.label}>Fecha de pago</label>
              <input type="date" style={cs.input} value={modalPago.fecha_pago} onChange={e=>setModalPago(p=>({...p,fecha_pago:e.target.value}))}/>
            </div>
            <div style={{ display:'flex', gap:'10px', marginTop:'20px', justifyContent:'flex-end' }}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>setModalPago(null)}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnG}} onClick={registrarPago}>✓ Confirmar pago</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );
}
